export default __webpack_public_path__ + "static/media/arrived.550a9853.png";